<template>
  <v-sheet height="100%" color="transparent">
    <div class="videos primary darken-4" v-if="!loading">
      <portfolio :items="items" />
    </div>
    <v-sheet
      v-else
      class="d-flex justify-center align-center"
      height="100%"
      width="100%"
      color="transparent"
    >
      <v-progress-circular
        :size="50"
        color="white"
        indeterminate
      ></v-progress-circular>
    </v-sheet>
  </v-sheet>
</template>

<script>
import Portfolio from "../widgets/Portfolio.vue";
import { formatToURL } from "../utils";

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    items() {
      if (!this.$rest("portfolio").list.length) return [];
      return this.$rest("portfolio").list.map(
        ({ id, img_cover_desktop, img_cover_mobile, title, subtitle }) => ({
          img_cover_desktop,
          img_cover_mobile,
          title,
          subtitle,
          to: `/portfolio/${formatToURL(title)}-${id}`,
        })
      );
    },
  },
  mounted() {
    this.$rest("portfolio")
      .get({
        params: {
          itemsPerPage: 3,
          highlight: 1,
        },
      })
      .then(() => (this.loading = false));
  },
  components: {
    Portfolio,
  },
};
</script>
